export default function BaseUrl(){
    // return "http://192.168.1.62:8000/api";
    // return "http://192.168.1.49:8000/api";
    return "https://yaako.tech/api";
    // return "http://yaako.tech/api";
}

